var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPioneering(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 92,
    viewBox: "0 0 95 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_198_23903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.2832 63.6583L76.0111 1.10095",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.02539 66.3923L26.0479 47.4323C27.6001 46.2683 30.2233 46.3934 31.7071 45.1432L55.0563 25.47C56.7338 24.0566 57.0293 20.5821 58.6128 19.0642L77.4182 3.3092",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.553 28.6263L18.8662 91.1492",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3747 25.2089L77.4205 36.7007C75.8683 37.8647 73.2451 37.7396 71.7614 38.9898L48.4121 58.663C46.7346 60.0764 46.4391 63.5509 44.8556 65.0688L16.9199 88.1948",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65527 75.2255L25.8571 60.6395C27.4438 59.294 28.52 57.4443 28.9054 55.4L30.121 48.9524C30.513 46.8734 31.6191 44.9968 33.2481 43.6469L54.1661 26.3132C55.3602 25.3237 56.788 24.6568 58.3131 24.3761L67.7064 22.6473C69.2208 22.3686 70.6393 21.7091 71.8284 20.7309L82.78 11.7218",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6201 78.3101L27.8961 63.5511C29.6378 62.0631 31.8779 61.289 34.1667 61.3842L41.2518 61.6787C43.5223 61.7731 45.7455 61.0121 47.4818 59.5463L69.2651 41.1567C70.1968 40.3701 70.9604 39.4039 71.5103 38.3156C72.0602 37.2273 72.3852 36.0394 72.4657 34.8227L72.8302 29.316C72.9103 28.1056 73.2323 26.9236 73.7772 25.8399C74.322 24.7561 75.0786 23.7926 76.0022 23.0063L85.0577 15.2971",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2822 49.0649L34.6665 48.745",
    stroke: "#F69A4D",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9209 46.8688L59.8398 27.7935",
    stroke: "#F69A4D",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "0.98 2.93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9668 26.8552L61.3511 26.5354",
    stroke: "#F69A4D",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4014 52.3902L36.7856 52.0703",
    stroke: "#F69A4D",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.04 50.194L61.9589 31.1187",
    stroke: "#F69A4D",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "0.98 2.93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0859 30.1806L63.4703 29.8607",
    stroke: "#F69A4D",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5205 55.7154L38.9048 55.3955",
    stroke: "#F69A4D",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1592 53.5193L64.0781 34.444",
    stroke: "#F69A4D",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "0.98 2.93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2051 33.5058L65.5894 33.1859",
    stroke: "#F69A4D",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6396 59.0406L41.024 58.7207",
    stroke: "#F69A4D",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2783 56.8445L66.1972 37.7692",
    stroke: "#F69A4D",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "0.98 2.93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3242 36.8311L67.7086 36.5112",
    stroke: "#F69A4D",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_198_23903"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 92,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPioneering);
export default __webpack_public_path__ + "static/media/pioneering.b1918d16bbc69c5c8898ad06658be469.svg";
export { ForwardRef as ReactComponent };